/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payments_Filter_RefundInputs */

const fr_payments_filter_refund = /** @type {(inputs: Payments_Filter_RefundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remboursements`)
};

/**

* @param {Payments_Filter_RefundInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payments_filter_refund = /** @type {((inputs?: Payments_Filter_RefundInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payments_Filter_RefundInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payments_filter_refund(inputs)
});